import React from "react";
import Dialog from "carbon-react/lib/components/dialog";
import DialogConfirmButtons from "../dialogConfirmButtons/DialogConfirmButtons";

import "./ConfirmDialog.css";

const ConfirmDialog = ({
  open,
  title = "Confirm",
  prompt,
  onConfirm,
  onCancel,
  confirmBtnLabel = "Confirm",
  cancelBtnLabel = "Cancel",
  confirmBtnAutoFocus = false,
  cancelBtnAutoFocus = true,
  omitCancelBtn = false,
}) => {
  const isAValidFunc = (func) => {
    return func && typeof func === "function";
  };

  const onDialogConfirm = () => {
    if (isAValidFunc(onConfirm)) onConfirm();
  };

  const onDialogCancel = () => {
    if (isAValidFunc(onCancel)) onCancel();
  };

  const dialogButtons = (
    <DialogConfirmButtons
      confirmBtnLabel={confirmBtnLabel}
      confirmBtnAutoFocus={confirmBtnAutoFocus}
      onConfirm={onDialogConfirm}
      cancelButtonLabel={cancelBtnLabel}
      cancelBtnAutoFocus={cancelBtnAutoFocus}
      onCancel={onDialogCancel}
      omitCancelBtn={omitCancelBtn}
    />
  );

  const dialogBody = (
    <div className="confirm-dialog-prompt">
      <span>{prompt}</span>
    </div>
  );

  return (
    <Dialog
      open={open}
      showCloseIcon={true}
      onCancel={onDialogCancel}
      size="small"
      title={title}
    >
      {dialogBody}
      {dialogButtons}
    </Dialog>
  );
};

export default ConfirmDialog;
